import { createSlice } from "@reduxjs/toolkit";
import initialState from "./globalInitialState";
import globalActions from "./globalActions";

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: globalActions,
});

export const {
  setDisableBtn,
  setShowPaymentPlans,
  setIsLoading,
  setRerender,
  setPackages,
  setCompanyTags,
  setStepsBack,
  setCountries,
  setRerenderList,
  setMediaIdReset,
  setRerenderSubscription,
  setCompanyDetails,
  setSubscriptionInfo,

  setUserInfo,
  setIsAuthenticated,

  setLayerOptions,
  setSelectedApp,
  setAssign,
  setLayer,
  setAddContentSource,
  setLayerSettingsTab,
  setType,
  setIsPrayerCampaign,
  setHideTabs,
  setCampaignDetails,
  setIsPublished,
  setSelectedMediaInfo,
  setDeletedItemId,
  setProfileImage,

  setDeleteDialog,
  setOpenDialog,

  toggleDialog,
  setDialog,
  toggleLoader,
  toggleDeleteDialog,
} = globalSlice.actions;

export default globalSlice.reducer;
